module.exports = __webpack_public_path__ + "static/vr-4-2-8d8a6badc890477bf81a1aee8b7546b0.jpeg";